export default __webpack_public_path__ + "static/media/complete.3083f986.svg";